import { PHOTO_COMMENT_FORM } from "../constants"

class FormCommentElement {
  constructor(element) {
    this.element = element
    this._initializeJsCheck()
    this._initializedNameField = false
  }

  static fromHtmlElement(htmlElement) {
    const element = htmlElement.querySelector(PHOTO_COMMENT_FORM)
    return element ? new FormCommentElement(element) : null
  }

  _initializeJsCheck() {
    if (!this.element) return

    // Ensure jscheck field is set to "ok" before form submission
    const jscheckInput = this.element.querySelector('input[name="jscheck"]')
    if (jscheckInput) {
      jscheckInput.value = "ok"
    }

    // Also set it on form submit as a safety measure
    this.element.addEventListener("submit", () => {
      if (jscheckInput) {
        jscheckInput.value = "ok"
      }
    })
  }

  apply(photo) {
    if (!this.element) return

    // Update form action URL to point to the current photo
    // The form action should be /photos/:photo_id/comments
    if (photo && photo.id) {
      this.element.action = `/photos/${photo.id}/comments`
    }

    // Ensure jscheck is still set after photo changes
    const jscheckInput = this.element.querySelector('input[name="jscheck"]')
    if (jscheckInput) {
      jscheckInput.value = "ok"
    }

    // Initialize name field only once (on first load)
    // After that, preserve user's input when navigating between photos
    const nameInput = this.element.querySelector('input[name="comment[author_name]"]')
    if (nameInput && !this._initializedNameField && !nameInput.value) {
      // Name field is empty, so initialize it with the default value from the template
      // The template already sets the value, so this is just a safety check
      this._initializedNameField = true
    }

    // Ensure honeypot field remains empty (it's hidden from users)
    // If a bot fills it, the controller will reject the submission
    const honeypotInput = this.element.querySelector('input[name="phone"]')
    if (honeypotInput) {
      honeypotInput.value = ""
    }
  }
}

export default FormCommentElement
